import { createTheme, accordionSummaryClasses } from '@mui/material';

import { palette } from './palette';

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1208 + 48,
      xxl: 1490 + 48, // Кастомный брейкпоинт
    },
  },
  palette,
  typography: {
    fontFamily: "'Roboto', sans-serif",
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        img: {
          height: 'auto',
          maxWidth: '100%',
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        text: {
          transition: 'all .3s ease',
          '&:hover': {
            color: '',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          display: 'block',
          marginBottom: 8,
          // если используется вне инпута
          ':not(.MuiInputLabel-root)': {
            color: palette.text?.primary,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&:first-of-type, &:last-of-type': {
            borderRadius: 16,
          },
          '&:before': {
            display: 'none',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          padding: '8px 32px 8px 24px',
          minHeight: 'auto',
          [`&.${accordionSummaryClasses.expanded}`]: {
            minHeight: 'auto',
          },
        },
        content: {
          margin: '12px 0',
          [`&.${accordionSummaryClasses.expanded}`]: {
            margin: '12px 0',
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: '0 24px 24px',
        },
      },
    },
  },
});
